// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import Nestable from "react-nestable";

// Import components
import {NestableItem} from "../../components/cards/nestableItem";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import { deleteItem} from "../../utils/helperFunctions";
import {
    GetAdvertisements,
    DeleteAdvertisementById,
    UpdateAdvertisementsPositions,
} from "../../redux/actions";


class Advertisement extends Component {
    constructor(props) {
        super(props);

        this.deleteAdvertisement = deleteItem.bind(this, props.DeleteAdvertisementById, 'Գովազդը');
        this.onPositionChange = this.onPositionChange.bind(this);
    }

    componentDidMount() {
        this.props.GetAdvertisements();
    }

    getNestableItems(list, parent = null) {
        const items = [];
        list && !!list.length && list.forEach((item, index) => {
            items.push({
                id: item.id,
                index: index,
                title: item.title || " ",
                withImage: true,
                isHidden: item.isHidden,
                path: item?.mediaMain?.path,
                link: {
                    pathname: `advertisement/edit/${item.id}`,
                },
                deleteCb: () => this.deleteAdvertisement(item.id),
                children: []
            })
        });
        return items;
    }

    async onPositionChange(items, item) {
        const movedAdvertisementId = item.id;
        const {advertisements} = this.props;
        const positionedItems = items.map((item, index) => {
            return {id: item.id, position: index}
        });
        if (~advertisements.findIndex(m => m.id === movedAdvertisementId) &&
            ~positionedItems.findIndex(m => m.id === movedAdvertisementId)) {
            // first level menu was re-positioned in first level
            await this.props.UpdateAdvertisementsPositions(positionedItems);
            this.props.GetAdvertisements();
        }
    }

    render() {
        let {advertisements} = this.props;

        let items = this.getNestableItems(advertisements);
        return <PageWrapper pageTitle={'Գովազդներ'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={`/advertisement/add`}/>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetAdvertisements,
    DeleteAdvertisementById,
    UpdateAdvertisementsPositions
};

export default connect(mapStateToProps, mapDispatchToProps)(Advertisement);
